import { MouseEvent, ReactElement, useRef, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import Button from '../../components/common/Button/Button';
import Selectors from '../../components/mydata/Selectors/Selectors';
import { ReactComponent as SvgView } from '../../aassets/ic/ic_search_doc.svg';
import { ReactComponent as SvgOk } from '../../aassets/ic/ui/ic_ok.svg';
import { ReactComponent as SvgSad } from '../../aassets/ic/ui/is_sad.svg';
import {
	MydataQuestion,
	MydataResponse,
	QuestionStr,
	Q_STATUS_STR,
	ReactPressVars,
	SelectOpt,
} from '../../types';
import s from './mydata.module.scss';
import { useMedia } from 'react-use';
import BundleContent from '../../components/quiz/BundleContent/BundleContent';
import SingleQuestion from '../../components/quiz/SingleQuestion/SingleQuestion';
import Modal from 'react-modal';

interface Props {
	root: HTMLElement;
	wpdata: ReactPressVars;
	// isDev: boolean;
}
const MyData = ({ root, wpdata }: Props) => {
	const isWide = useMedia('(min-width: 1200px)', false);
	let selectedQuestions: ReactElement[] = [];

	const { questions, bundles, opts, cats } =
		useLoaderData() as MydataResponse;

	const [prodState, setProdState] = useState<SelectOpt>();
	const [domState, setDomState] = useState<SelectOpt>();
	const [catState, setCatState] = useState<SelectOpt>();
	const [subjState, setSubjState] = useState<SelectOpt>();
	const [lvlState, setLvlState] = useState<SelectOpt>();

	const handleProdChange = (value: any) => {
		setProdState(value);
		setDomState(undefined);
		setCatState(undefined);
		setSubjState(undefined);
		setLvlState(undefined);
	};
	const handleDomChange = (value: any) => {
		setDomState(value);
		setCatState(undefined);
		setSubjState(undefined);
		setLvlState(undefined);
	};
	const handleCatChange = (value: any) => {
		setCatState(value);
		setSubjState(undefined);
		setLvlState(undefined);
	};
	const handleSubjChange = (value: any) => {
		setSubjState(value);
	};
	const handleLvlChange = (value: any) => {
		setLvlState(value);
	};

	const time = useRef<string | undefined>();

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalContent, setModalContent] = useState<{
		bundleConent?: string;
		question: QuestionStr;
	}>();

	if (wpdata.user.ID === 0) {
		return (
			<div className={s.rt}>
				<div className={`${s.cnt} ${s.cnt_top}`}>
					<h1 className="app_h1">הנתונים שלי</h1>
				</div>
				<p className={s.guest_notice}>
					<i>
						לתשומת ליבך, על מנת לצפות בנתוני התרגול יש להירשם (ללא
						עלות) ולהתחבר למערכת
					</i>
					<a href="/registration/" className={s.reg_url}>
						להרשמה
					</a>
				</p>
			</div>
		);
	}

	const handleViewClick = (e: MouseEvent, question: MydataQuestion): void => {
		e.preventDefault();
		e.stopPropagation();

		time.current = question.solving_time;

		const newq = { ...question, status: parseInt(question.status) };
		setModalContent({
			bundleConent:
				prodState && question.bundle_id
					? bundles[prodState.value].find(
							(b) => b.id === question.bundle_id
					  )?.content ?? undefined
					: undefined,
			question: newq as QuestionStr,
		});
		setModalIsOpen(true);
	};

	const buildQuestion = (
		q: MydataQuestion,
		key: string,
		dom?: string,
		cat?: string,
		subj?: string
	) => {
		return isWide ? (
			<div className={s.qw} key={`qw${key}`}>
				<div className={s.qw_makat}>{q.id}</div>
				<div className={s.qw_status}>
					{q?.status === Q_STATUS_STR.RIGHT ? (
						<div className={s.qw_status_ok}>
							<SvgOk />
							<span>ענית נכון</span>
						</div>
					) : q.status === Q_STATUS_STR.TIMED ? (
						<div className={s.qw_status_err}>
							<SvgSad />
							<span>אזל הזמן</span>
						</div>
					) : (
						<div className={s.qw_status_err}>
							<SvgSad />
							<span>טעית</span>
						</div>
					)}
				</div>
				<div className={s.qw_time}>{q.solving_time ?? ''}</div>
				<div className={s.qw_cat}>{cat ?? ''}</div>
				<div className={s.qw_lvl}>
					{q.is_700 ? q.level_700 : q.level}
				</div>

				<div className={s.qw_view}>
					<Button
						width="inline"
						size="small"
						customClass={s.btn_view}
						isWithIcon
						onClick={(e) => handleViewClick(e, q)}>
						צפה
						<SvgView />
					</Button>
				</div>
			</div>
		) : (
			<div className={s.q} key={`q${key}`}>
				<div className={s.mrow}>
					<div className={`${s.mrow_in} ${s.mrow_title}`}>ID</div>
					<div className={`${s.mrow_in} ${s.mrow_title}`}>
						קטגוריה
					</div>
				</div>
				<div className={s.mrow}>
					<div className={s.mrow_in}>{q.id}</div>
					<div className={s.mrow_in}>{cat ?? ''}</div>
				</div>

				<div className={s.mrow}>
					<div className={`${s.mrow_in} ${s.mrow_title}`}>מענה</div>
					<div className={`${s.mrow_in} ${s.mrow_title}`}>
						זמן פיתרון
					</div>
				</div>
				<div className={s.mrow}>
					<div className={`${s.mrow_in} ${s.q_status}`}>
						{q?.status === Q_STATUS_STR.RIGHT ? (
							<div className={s.q_status_ok}>
								<SvgOk />
								<span>ענית נכון</span>
							</div>
						) : q.status === Q_STATUS_STR.TIMED ? (
							<div className={s.q_status_err}>
								<SvgSad />
								<span>אזל הזמן</span>
							</div>
						) : (
							<div className={s.q_status_err}>
								<SvgSad />
								<span>טעית</span>
							</div>
						)}
					</div>
					<div className={s.mrow_in}>{q.solving_time}</div>
				</div>

				<div className={s.mrow}>
					<div className={`${s.mrow_in} ${s.mrow_title}`}>
						רמת קושי
					</div>
					<div className={`${s.mrow_in} ${s.mrow_title}`}></div>
				</div>
				<div className={s.mrow}>
					<div className={s.mrow_in}>
						{q.is_700 ? q.level_700 : q.level}
					</div>
					<div className={s.mrow_in}></div>
				</div>

				<div className={s.q_view}>
					<Button
						width="full"
						customClass={s.btn_mview}
						isWithIcon
						onClick={(e) => handleViewClick(e, q)}>
						צפה
						<SvgView />
					</Button>
				</div>
			</div>
		);
	};

	if (prodState) {
		selectedQuestions = [];
		const qs = questions[prodState.value];
		if (catState) {
			if (subjState) {
				const subjId = subjState.value;
				if (lvlState) {
					const lvl = lvlState.value;
					qs.forEach((q, i) => {
						if (q.subject_id === subjId) {
							if (q.level === lvl) {
								selectedQuestions.push(
									buildQuestion(
										q,
										`q${q.id}i${i}`,
										domState?.label,
										catState.label,
										subjState.label
									)
								);
							} else if (q.level_700 === lvl) {
								selectedQuestions.push(
									buildQuestion(
										q,
										`q${q.id}i${i}`,
										domState?.label,
										catState.label,
										subjState.label
									)
								);
							}
						}
					});
				} else {
					qs.forEach((q, i) => {
						if (q.subject_id === subjId) {
							selectedQuestions.push(
								buildQuestion(
									q,
									`q${q.id}i${i}`,
									domState?.label,
									catState.label,
									subjState.label
								)
							);
						}
					});
				}
			} else {
				const catId = catState.value;
				if (lvlState) {
					const lvl = lvlState.value;
					qs.forEach((q, i) => {
						if (q.category_id === catId) {
							if (q.level === lvl) {
								selectedQuestions.push(
									buildQuestion(
										q,
										`q${q.id}i${i}`,
										domState?.label,
										catState.label
									)
								);
							} else if (q.level_700 === lvl) {
								selectedQuestions.push(
									buildQuestion(
										q,
										`q${q.id}i${i}`,
										domState?.label,
										catState.label
									)
								);
							}
						}
					});
				} else {
					qs.forEach((q, i) => {
						if (q.category_id === catId) {
							selectedQuestions.push(
								buildQuestion(
									q,
									`q${q.id}i${i}`,
									domState?.label,
									catState.label
								)
							);
						}
					});
				}
			}
		} else if (domState) {
			const domId = domState.value;
			qs.forEach((q, i) => {
				if (q.domain_id === domId) {
					selectedQuestions.push(
						buildQuestion(q, `q${q.id}i${i}`, domState?.label)
					);
				}
			});
		} else {
			qs.forEach((q, i) => {
				selectedQuestions.push(
					buildQuestion(
						q,
						`q${q.id}i${i}`,
						cats.domains.find((d) => d.id === q.domain_id)?.name,
						cats.categories.find((c) => c.id === q.category_id)
							?.name,
						cats.subjects.find((s) => s.id === q.subject_id)?.name
					)
				);
			});
		}
	}

	return (
		<>
			<div className={s.rt}>
				<div className={`${s.cnt} ${s.cnt_top}`}>
					<h1 className="app_h1">הנתונים שלי</h1>
				</div>
				<div className={`${s.cnt} ${s.cnt_content}`}>
					<Selectors
						opts={opts}
						prodState={prodState}
						domState={domState}
						catState={catState}
						subjState={subjState}
						lvlState={lvlState}
						handleProdChange={handleProdChange}
						handleDomChange={handleDomChange}
						handleCatChange={handleCatChange}
						handleSubjChange={handleSubjChange}
						handleLvlChange={handleLvlChange}
					/>
					<div className={s.qs}>
						{isWide && (
							<div className={`${s.qw} ${s.qws_titles}`}>
								<div className={s.qw_makat}>ID</div>
								<div className={s.qw_status}>מענה</div>
								<div className={s.qw_time}>זמן פיתרון</div>
								<div className={s.qw_cat}>קטגוריה</div>
								<div className={s.qw_lvl}>קושי</div>
								<div className={s.qw_view}></div>
							</div>
						)}
						{selectedQuestions}
					</div>
				</div>
			</div>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => setModalIsOpen(false)}
				contentLabel="תמונה"
				closeTimeoutMS={300}
				className={{
					base: s['m__content'],
					afterOpen: s['m__content--after-open'],
					beforeClose: s['m__content--before-close'],
				}}
				overlayClassName={{
					base: s['m__overlay'],
					afterOpen: s['m__overlay--after-open'],
					beforeClose: s['m__overlay--before-close'],
				}}
				appElement={root}>
				<div className={s.timer}>
					<div className={s.timer_inn}>{time.current}</div>
				</div>
				{modalContent?.bundleConent && (
					<div className={s.b_ctn_wrp}>
						<BundleContent
							content={modalContent.bundleConent}
							show={false}
						/>
					</div>
				)}
				{modalContent?.question && (
					<SingleQuestion
						q={modalContent.question}
						isTimed={false}
						showSolution={true}
						onAnswerSelectCallback={(isRight: boolean) => {}}
						isQuiz={false}
					/>
				)}

				<button
					className={s.m__btn}
					onClick={() => setModalIsOpen(false)}>
					X
				</button>
			</Modal>
		</>
	);
};
export default MyData;
